export default "__VITE_ASSET__7e3112e4__"